import type { ChannelSummary } from '@pulsify/shared'
import { FollowQrCard } from '~/features/organizer/components/follow-qr-card'
import { MembersCard } from '~/features/organizer/components/members-card'
import { OrganizerDetailsCard } from '~/features/organizer/components/organizer-details-card'
import { OrganizerProfileHeader } from '~/features/organizer/components/organizer-profile-header'
import { ShareLinksCard } from '~/features/share-links/share-links-card'
import { Skeleton } from '~/shared/ui/skeleton'
import { DetailPageGrid } from '~/widgets/detail-page-grid'

/** A filled-in organizer page: header, details and members to read and edit, and its sharing cards. */
export function OrganizerProfileOverview({
  businessId,
  channel,
}: {
  businessId: string
  channel: ChannelSummary
}) {
  return (
    <div className="mx-auto w-full max-w-7xl space-y-6">
      <OrganizerProfileHeader businessId={businessId} channel={channel} />
      <DetailPageGrid
        side={
          <>
            <FollowQrCard businessId={businessId} channel={channel} />
            <ShareLinksCard
              businessId={businessId}
              target={{ kind: 'profile', id: channel.id }}
              title={channel.name}
            />
          </>
        }
      >
        <OrganizerDetailsCard businessId={businessId} channel={channel} />
        <MembersCard businessId={businessId} channelId={channel.id} name={channel.name} />
      </DetailPageGrid>
    </div>
  )
}

export function OrganizerProfileOverviewSkeleton() {
  return (
    <div className="mx-auto w-full max-w-7xl space-y-6">
      <Skeleton className="h-80 w-full rounded-xl lg:h-56" />
      <DetailPageGrid side={<Skeleton className="h-96 w-full rounded-xl" />}>
        <Skeleton className="h-72 w-full rounded-xl" />
      </DetailPageGrid>
    </div>
  )
}
